import { Invitation } from "./invitation";

export class InvitationError extends Error {
    
    constructor(
      public code: string,
      message: string,
      public invitation?: Invitation,
      public override cause?: unknown
    ) {
      super(message);
      this.name = 'InvitationError';
    }
  
    static empty() {
      return new InvitationError('EMPTY_INVITATION', 'No invitation provided');
    }
  
    static incomplete(invitation?: Invitation) {
      return new InvitationError('INCOMPLETE_INVITATION', 'Invitation data is incomplete', invitation);
    }
  
    static selfInvitation(invitation?: Invitation) {
      return new InvitationError('SELF_INVITATION', 'Cannot accept self-invitation', invitation);
    }
  
    static notConference(invitation?: Invitation) {
      return new InvitationError('NOT_CONFERENCE', 'Invitation is not for a conference', invitation);
    }
  
    static alreadyAcknowledged(invitation?: Invitation) {
      return new InvitationError('ALREADY_ACKNOWLEDGED', 'Invitation is already acknowledged', invitation);
    }
}